export const container = ({ theme: { colors } }) => ({
    borderBottom: `0.0625rem solid ${colors.lightGrey}`,
});
